import { FulfillmentOrderAddressSchema } from "@redotech/redo-model/fulfillments/fulfillment-order-address";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const updateFulfillmentGroupAddress = {
  name: "updateFulfillmentGroupAddress" as const,
  input: z.object({
    fulfillmentGroupId: zExt.objectId(),
    address: FulfillmentOrderAddressSchema,
  }),
  output: z.object({ success: z.boolean() }),
};
